import { Tooltip } from '@mui/material';
import { connect } from 'redux-bundler-react';
import { keyframes } from '@emotion/react';
import { withStyles } from 'tss-react/mui';
import React from 'react';

const pulse = keyframes`
  0% { transform: scale(1); opacity: 0.55; }
  100% { transform: scale(2.8); opacity: 0; }
`;

const styles = () => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 10,
    padding: '0 14px',
    height: 36,
    borderRadius: 999,
    backgroundColor: 'rgba(255, 255, 255, 0.06)',
    color: '#fff',
    fontSize: 13,
    lineHeight: 1,
    boxSizing: 'border-box',
    userSelect: 'none',
  },
  pulseWrap: {
    position: 'relative',
    width: 8,
    height: 8,
    flexShrink: 0,
  },
  dot: {
    position: 'absolute',
    inset: 0,
    borderRadius: '50%',
    backgroundColor: '#22c55e',
  },
  pulseRing: {
    position: 'absolute',
    inset: 0,
    borderRadius: '50%',
    backgroundColor: '#22c55e',
    animation: `${pulse} 2s ease-out infinite`,
  },
  metric: {
    display: 'inline-flex',
    alignItems: 'baseline',
    gap: 5,
  },
  number: {
    fontWeight: 600,
    fontSize: 14,
    fontVariantNumeric: 'tabular-nums',
  },
  label: {
    color: 'rgba(255, 255, 255, 0.6)',
  },
  divider: {
    color: 'rgba(255, 255, 255, 0.25)',
    fontSize: 14,
  },
});

const PlatformActivityIndicator = ({
  classes,
  platformActivities,
  privacyMode,
  showPlatformActivity,
}) => {
  if (!showPlatformActivity) return null;
  if (privacyMode) return null;
  if (platformActivities.forbidden) return null;
  const item = platformActivities.item;
  if (!item) return null;

  return (
    <Tooltip title="Active users in the last 30 minutes / 24 hours">
      <div className={classes.root}>
        <span className={classes.pulseWrap}>
          <span className={classes.pulseRing} />
          <span className={classes.dot} />
        </span>
        <span className={classes.metric}>
          <span className={classes.number}>{item.activeUsersLast30m}</span>
          <span className={classes.label}>now</span>
        </span>
        <span className={classes.divider}>|</span>
        <span className={classes.metric}>
          <span className={classes.number}>{item.activeUsersLast24h}</span>
          <span className={classes.label}>today</span>
        </span>
      </div>
    </Tooltip>
  );
};

export default connect(
  'selectPlatformActivities',
  'selectPrivacyMode',
  'selectShowPlatformActivity',
  withStyles(PlatformActivityIndicator, styles),
);
